import { render, staticRenderFns } from "./Swatch.vue?vue&type=template&id=517de612&scoped=true&shadow"
import script from "./Swatch.vue?vue&type=script&lang=js&shadow"
export * from "./Swatch.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Swatch.vue?vue&type=style&index=0&id=517de612&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../.nvm/versions/node/v14.16.1/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "517de612",
  null
  ,true
)

export default component.exports